let language = {
    "LBL_HOME":"Home",
    "LBL_DEFAULT_SEARCH":"Search",
    "LBL_DEFAULT_ADMIN":"Admin",
    "LBL_ADD_USER_REPORTS":"New User Report",
    "LBL_VIEW_USER_REPORTS":"View User Reports",
    "LBL_PDF_REQUESTS":"PDF Requests",
    "LBL_DEFAULT_USER":"User",
    "LBL_SCHEDULER":"Schedule",
    "LBL_DEFAULT_REPORTS":"Reports",
    "LBL_USER_NAME":"User Name",
    "LBL_REPORT_NAME":"Report Name",
    "LBL_USER_REPORT_LIST":"User Reports List",
    "LBL_DETAIL_VIEW":"Details View",
    "LBL_REQUEST_ACTION":"Request Action",
    "LBL_REQUEST_NUMBER":"Request Number",
    "LBL_ASSIGNED_TO":"Assigned to",
    "LBL_PDF_REQUEST_LIST":"PDF Requests",
    "":"setting",
    "":"setting",
    "":"setting",
    "":"setting",
    "":"setting",
    
}

export default language;